import { usePodcastProvider } from "components/podcast/PodcastProvider";
import { TelegramShareButton, TwitterShareButton } from "react-share";
//ui
import { Button, Flex, Input, Text, IconButton, useClipboard } from "@chakra-ui/react";
import { TwitterFilledIcon, TelegramIcon, ChevronFillIcon } from "components/icons";
import { MdOutlineContentCopy } from "react-icons/md";

export function ShareModalContent() {
  const { onClose, modalPodcast, descriptionData } = usePodcastProvider();
  const { hasCopied, onCopy } = useClipboard(`${window.location.href}?episode_number=${modalPodcast?.episode_number}`);
  return (
    <Flex flexDir="column" pt="12px" color="purple.50" width="100%" alignItems={{ base: "flex-start", md: "center" }} px={{ base: "8px", md: "0px" }}>
      <IconButton
        icon={<ChevronFillIcon width="48px" height="48px" />}
        width="24px"
        aria-label="close-modal"
        bg="transparent"
        borderRadius="24px"
        _hover={{ bg: "transparent" }}
        color="purple.50"
        onClick={onClose}
        display={{ base: "flex", md: "none" }}
      />
      <Flex width="100%" px={{ base: "31px", md: "0px" }} justifyContent="center" flexDir="column" pt={{ base: "16px", md: "0px" }}>
        <Flex
          justifyContent="center"
          fontWeight="600"
          letterSpacing="-0.02em"
          fontSize={{ base: "24px", md: "32px" }}
          mx="auto"
          lineHeight={{ base: "32px", md: "40px" }}
          maxWidth="650px"
          width="100%"
        >
          <Text textAlign="center" as="h5">
            Share this episode
          </Text>
        </Flex>
        <Flex mt="36px" letterSpacing="-0.01em" fontSize="16px" mx="auto" lineHeight="20px">
          <Text mr="5px" as="h5">
            Share
          </Text>
          <Text fontWeight="700" as="h5">
            &ldquo;{modalPodcast?.title}&rdquo;
          </Text>
        </Flex>
        <Flex maxWidth="650px" flexDirection={{ base: "column", md: "row" }} mx="auto" width="100%" mt="36px" alignItems="center" justifyContent={{ base: "center" }}>
          <Input
            letterSpacing="-0.01em"
            fontSize="16px"
            lineHeight="20px"
            type="text"
            readonly
            height="48px"
            maxWidth="424px"
            width="100%"
            borderRadius="6px"
            color="purple.200"
            bg="purple.150"
            _placeholder={{ color: "inherit" }}
            _focus={{ outlineColor: "#6B5FA5" }}
            value={`${window.location.href}?episode_number=${modalPodcast?.episode_number}`}
            readOnly
          />
          <Button
            borderRadius="6px"
            alignItems="center"
            spacing="50px"
            bg="purple.100"
            maxWidth="200px"
            py="12px"
            height="48px"
            px="24px"
            color="#FCFCFC"
            fontSize="16px"
            lineHeight="24px"
            fontWeight="600"
            letterSpacing="0.05em"
            font="sora"
            mt={{ base: "38px", md: "0" }}
            _hover={{
              bg: "purple.100",
              color: "#FFFFFF"
            }}
            ml={{ sm: "24px" }}
            onClick={onCopy}
          >
            <MdOutlineContentCopy size="18px" />
            <Text fontWeight="600" ml="12px" as="h5">
              {hasCopied ? <Text color="inherit">Copied!</Text> : <Text color="inherit">Copy Link</Text>}
            </Text>
          </Button>
        </Flex>
        <Text mt="36px" letterSpacing="-0.01em" mx="auto" fontSize="16px" lineHeight="20px" as="h5">
          Or share on social media
        </Text>
        <Flex mt="36px" maxWidth={{ base: "310px", md: "385px" }} mx="auto" width="100%" pb={{ base: "82px", md: "36px" }} justifyContent="center">
          <TwitterShareButton
            title={`“Check out ${modalPodcast?.title} from ${descriptionData?.title}! They earn rewards whenever you listen.”`}
            url={`${window.location.href}?episode_number=${modalPodcast?.episode_number}`}
            style={{
              height: "32px",
              marginRight: "15px"
            }}
          >
            <TwitterFilledIcon color="purple.100" width="32px" height="32px" />
          </TwitterShareButton>
          <TelegramShareButton
            title={`“Check out ${modalPodcast?.title} from ${descriptionData?.title}! They earn rewards whenever you listen.”`}
            url={`${window.location.href}?episode_number=${modalPodcast?.episode_number}`}
            style={{
              height: "32px",
              marginRight: "15px"
            }}
          >
            <TelegramIcon color="purple.100" width="32px" height="32px" />
          </TelegramShareButton>
        </Flex>
      </Flex>
    </Flex>
  );
}
